// MissingTranslationsPlugin.js
import {I18n} from "laravel-vue-i18n";

const MissingTranslationsPlugin = {
    install(app, options) {

        const i18n = I18n.getSharedInstance();

        const environment = import.meta.env.VITE_APP_ENV;

        // Save a reference to the original method
        const originalMethod = app.config.globalProperties.$t;

        // Redefine the method with new functionality
        app.config.globalProperties.$t = (key, replacements) => {
            if (!i18n.isLoaded(i18n.getActiveLanguage())) {
                return i18n.trans(key, replacements);
            }
            if (environment === 'production') {
                return originalMethod(key, replacements);
            }
            if (!i18n.activeMessages.hasOwnProperty(key)) {
                if (environment === 'local') {
                    // Disabled for now - uncomment to enforce translation coverage in local environment
                    // throw new Error('%cMissing Translation: '+key);
                }
                console.error('%cMissing Translation: '+key);
            }
            // Optionally call the original method if needed
            return originalMethod(key, replacements);
        };
    }
};

export default MissingTranslationsPlugin;
